/* Campaign API */
export const MULTI_CAMPAIGN = '/api/datintell/v1/campaign_collections/';
export const GET_BUILDER_TABLE_VIEW =
  '/api/datintell/v1/builder/builder_schema/';
export const MEDIA_PLAN_ITEMS_META =
  '/api/datintell/v1/builder/media_plan_items_meta/';
export const MEDIA_PLANS = '/api/datintell/v1/builder/media_plans/';
export const PREDICTIVE_PLANNING_UPDATE = 'predictive_planning_update/';
export const PREDICTIVE_PLANNING_CREATE_AND_UPDATE =
  'predictive_planning_create_version_and_update/';

// Recommendations
export const RECOMMENDATIONS_ROOT = '/api/recommendations';
export const RECOMMENDATIONS_LIST = `${RECOMMENDATIONS_ROOT}/list`;
export const RECOMMENDATIONS_STATE = `${RECOMMENDATIONS_LIST}/state`;
export const RECOMMENDATIONS_SETTINGS = `${RECOMMENDATIONS_ROOT}/settings/parameters`;
export const RECOMMENDATIONS_WARNINGS = `${RECOMMENDATIONS_ROOT}/settings/warnings`;

//Recommendation settings - non applicable list
export const RECOMMENDATIONS_SETTINGS_NON_APPLICABLE_LIST_SEARCH =
  '/api/datintell/v1/builder/recommendations/non_applicable_list_search';

// Insertion Order API
export const IO = '/api/insertion-order/v1/';

export const GET_NEW_IO = `${IO}options/io/new`;
export const CREATE_NEW_IO = `${IO}io-entry`;

// Predictive Planning API
export const PREDICTIVE_PLANNING = '/api/predictive-planning/';
export const GET_PREDICTIVE_PLANING = `${PREDICTIVE_PLANNING}get-predictive-planning/`;
export const CHECK_HISTORICAL_DATA = `${PREDICTIVE_PLANNING}check-historical-data/`;
export const CHECK_AVAILABLE_METRICS = `${PREDICTIVE_PLANNING}check-available-metrics/`;

// Media plan Versions
export const MEDIA_PLAN_VERSIONS =
  'api/datintell/v1/builder/media_plan_versions/';
